var initUrl = "";
if (window.location.hostname.indexOf('192.168') !== -1 || window.location.hostname.indexOf('test') !== -1) {
  initUrl = "//test-sy.etolies.com";
} else {
  initUrl = "//sy.etolies.com";
}
export default {
  // 初始化
  syInit: initUrl + "/websdk/v1/init/index/",
  // 收集设备信息接口
  syWebDevice: "//collect.etolies.com/web/device/cl/",
  // 埋点数据上报接口
  syWebDot: "//collect.etolies.com/web/dot/cl/",
  // 错误日志上报接口
  syWebErrorlog: "//collect.etolies.com/web/errorlog/cl/",
  // sdk 数据上报
  RaStarUpload: "//collect.etolies.com/web/rolelog/cl/",

};